import React from 'react';

import { LinkContainer } from 'react-router-bootstrap';

import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';

const AboutStandardsCard = () => {
	return (
		<Container style={{ maxWidth: 1000 }}>
			<Card
				className='material-shadow my-4 mx-3 mx-md-5'
				style={{ borderRadius: 15, border: 'none' }}>
				<Row className='custom-vertical-align m-0'>
					<Col
						xs={12}
						md={5}
						className='d-flex align-items-md-center justify-content-center header-image-container px-0'>
						<Container
							className='mx-0 p-0 d-flex justify-content-center'
							style={{ position: 'relative' }}>
							<Image
								variant='top'
								src='/img/about-estandares.jpg'
								alt='About-Estandares-Image'
								className='about-inner-image m-md-0'
								height='200px'
							/>
							<div className='estandares-filter' />
						</Container>
					</Col>
					<Col xs={12} md={7} className='py-3 py-md-4 px-2 px-md-3'>
						<Card.Title
							as='h3'
							className='text-center'
							style={{ color: 'rgb(51, 103, 255' }}>
							Estándares
						</Card.Title>
						<Card.Body as='h5' className='text-center py-2 mx-0 mx-md-2'>
							Nuestros cursos cumplen con los más altos estándares en contenido
							como en metodología.
						</Card.Body>
						<Card.Body className='d-flex justify-content-center py-2'>
							<LinkContainer to={'/signup/'}>
								<Button
									variant=''
									size='md'
									className='btn-rounded btn-secondary shadow-sm px-4'>
									<strong>Deseo Conocer Más</strong>
								</Button>
							</LinkContainer>
						</Card.Body>
					</Col>
				</Row>
			</Card>
		</Container>
	);
};

export default AboutStandardsCard;
